/*
 * @Description:
 * @Version: 2.0
 * @Autor: shimnx
 * @Date: 2021-08-11 15:29:16
 * @LastEditors: Lan, Peng
 * @LastEditTime: 2023-07-04 11:21:07
 */
import { environment } from '@/environments/environment';
import { Component, Injectable, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
/**
 * 接口配置文件
 * baseurlnList
 * urlList
 */
@Injectable()
export class apiList implements OnInit {
  baseurl: any = '';
  projectList: any = {};
  uploadAttachmentUrl: string = '';
  constructor(public translate: TranslateService) {
    this.baseurl = environment.url;

    (this.projectList = {
      getRequestList:{
        path:'/WfReview/GetWfUserReviewList'
      },
      getChangeRequestDetailsById: {
        path: '/MaterialChange/GetChangeRequestDetailsById'
      },
      getL2ReasonByPid: {
        path: '/MaterialChange/GetLevel2ReasonTypeListByProjectId'
      },
      approvedRequest:{
        path:'/WfReview/ApproveRequest '
      },
      batchApproveRequest:{
        path:'/WfReview/BatchApproveRequest'
      },
      rejectRequest:{
        path:"/WfReview/RejectRequest"
      },
      downloadAttachment: {
        path: '/Cloud/ViewOnlineByUrl'
      },
      // E-check
      createMasterOption: {
        path: 'kimi-eCheck-option-master',
        methods: 'POST',
      },
      getInitialConditionDataByTypeAndId: {
        path: 'kimi-project-scrum-board/initial-condition-data-by-id-and-type',
      },
      getProjectChangeBasicInfo: {
        path: '/ProjectChange/GetProjectChangeBasicInfo'
      },
      getUserRequestList: {
        path: '/WfReview/GetWfUserRequestList'
      },
      getProjectChangeItem: {
        path: '/ProjectChange/GetProjectChangeItem'
      },
      saveOrUpdateProjectChangeInfo: {
        path: '/ProjectChange/SaveOrUpdateProjectChangeInfo'
      },
      submitProjectChange: {
        path: '/ProjectChange/SubmitProjectChange'
      },
      revokeRequest: {
        path: '/WfReview/RevokeRequest'
      },
      submitWfApprove: {
        path: '/WfReview/SubmitWfApprove'
      },
      deleteRequest: {
        path: '/WfReview/DeleteRequest'
      },
      copyRequest: {
        path: '/WfReview/CopyRequest'
      },
      getChangeRequestIsExist: {
        path: '/MaterialChange/GetChangeRequestIsExist'
      },
      getLevel2ReasonTypeListById: {
        path: '/MaterialChange/GetLevel2ReasonTypeListById'
      },
      updateMaterialChangeInfo: {
        path: '/MaterialChange/UpdateMaterialChangeInfo'
      },
      submitMaterialChangeInfo: {
        path: '/MaterialChange/SubmitMaterialChange'
      },
    }),

    this.uploadAttachmentUrl = environment.url + '/cloud/UpLoadAttachment2Storage';
  }
  ngOnInit() {}
}
